export const PLAYLIST_SONGS_SET = 'PLAYLIST_SONGS_SET';
export const PLAYLIST_SONGS_SEARCH = 'PLAYLIST_SONGS_SEARCH';
export const PLAYLIST_SONGS_SELECT = 'PLAYLIST_SONGS_SELECT';
export const PLAYLIST_SONGS_CLEAR = 'PLAYLIST_SONGS_CLEAR';
export const PLAYLIST_SONGS_GET_ERROR = 'PLAYLIST_SONGS_GET_ERROR';
export const PLAYLIST_SONGS_EDIT_PLAYLIST_SET = 'PLAYLIST_SONGS_EDIT_PLAYLIST_SET';